"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NOT_FOUND_KEY: true,
  ComboBox: true
};
exports.default = exports.NOT_FOUND_KEY = exports.ComboBox = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _tabbable = require("tabbable");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _ValidationMessage = require("../Forms/_ValidationMessage");
var _IconButton = require("../IconButton/IconButton");
var _InputField = require("../InputField/InputField");
var _Listbox = require("../List/Listbox");
var _isFunction = require("../utils/isFunction");
var _isString = require("../utils/isString");
var _Overlay = require("../Overlay/Overlay");
var _BusyIndicator = require("../BusyIndicator/BusyIndicator");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isEnterOrSpace = require("../utils/isEnterOrSpace");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _listOptions = require("../utils/_listOptions");
var _listboxUtils = require("../List/_listboxUtils");
var _MultiComboBoxTokenizer = require("./_MultiComboBoxTokenizer");
var _utils = require("./_utils");
var _ComboBoxContext = require("./_ComboBoxContext");
var _ComboBox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ComboBox.css") : void 0);
var _ComboBox2 = require("./ComboBox.types");
Object.keys(_ComboBox2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ComboBox2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ComboBox2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-len */

const CSS_BLOCK = 'sapcnqr-combobox';
const NOT_FOUND_KEY = exports.NOT_FOUND_KEY = 'none';
/** A **ComboBox** allows users to select an item from a predefined list.
 * It provides an editable input field for filtering the list,
 * and a dropdown menu with a list of the available options.
 * If the entries are not validated by the application, users can also enter custom values.
 *
 * > Browsers provide suggestions for input fields by default;
 * This component will attempt to disable those suggestions.
 * Please open an issue if you see browser suggestion behavior.
 * See the [support](/docs/introduction-support--docs#autocomplete-attribute-issue) page
 * for more information.
 *
 * Documentation is separated into sections:
 *
 * * [Basic Examples](./?path=/docs/components-controls-inputs-combobox-basic-examples--docs)
 * * [Customization Examples](./?path=/docs/components-controls-inputs-combobox-customization-examples--docs)
 *  */
const ComboBox = exports.ComboBox = /*#__PURE__*/_react.default.forwardRef((receivedProps, ref) => {
  var _a, _b;
  const defaultProps = (0, _react.useRef)({
    mruOptions: [],
    options: []
  });
  const _props = Object.assign(Object.assign({}, defaultProps.current), receivedProps);
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ComboBox, _props)) : _props;
  const {
      dropdownTriggerButtonRef,
      className,
      controlRef,
      decorators,
      disabled,
      dropdownTriggerButtonProps,
      dropdownTriggerIconName = 'navigation-down-arrow',
      dropdownTriggerLabel,
      filterable = true,
      filterableMruOptions = false,
      groupBy,
      helpText,
      hideNoResultsMsg,
      id,
      infinite,
      inputDescribedby,
      inputProps,
      inputRef,
      isLoading,
      itemCountScreenReaderLabel,
      itemKey = 'key',
      itemText = 'text',
      label,
      labelProps,
      listboxProps,
      listItemProps,
      listItemRenderer = 'text',
      loadingMessage,
      localizedTextAddendum,
      matcherMethod = 'startsWith',
      maxHeight = '30vh',
      mruOptions,
      mruListItemRenderer,
      onBlur,
      onChange,
      onDropdownClose,
      onDropdownOpen,
      onDropdownTriggerClick,
      onFocus,
      onKeyDown,
      onOverflowTokenClick,
      onMouseDown,
      onSelectionChange,
      onTokenClose,
      options,
      placeholder,
      overlayProps,
      readOnly,
      required,
      selectedKey,
      selectedKeys,
      selectionType = 'manual',
      showOnFocus,
      noResultsMsg,
      tokenizerRef,
      hideDropdownButton,
      showAllOptionsOnDropdownOpen,
      validationMessage,
      value = '',
      mruTitle,
      otherGroupHeader,
      groupClearTextRenderer,
      groupClearHandler
    } = props,
    otherProps = __rest(props, ["dropdownTriggerButtonRef", "className", "controlRef", "decorators", "disabled", "dropdownTriggerButtonProps", "dropdownTriggerIconName", "dropdownTriggerLabel", "filterable", "filterableMruOptions", "groupBy", "helpText", "hideNoResultsMsg", "id", "infinite", "inputDescribedby", "inputProps", "inputRef", "isLoading", "itemCountScreenReaderLabel", "itemKey", "itemText", "label", "labelProps", "listboxProps", "listItemProps", "listItemRenderer", "loadingMessage", "localizedTextAddendum", "matcherMethod", "maxHeight", "mruOptions", "mruListItemRenderer", "onBlur", "onChange", "onDropdownClose", "onDropdownOpen", "onDropdownTriggerClick", "onFocus", "onKeyDown", "onOverflowTokenClick", "onMouseDown", "onSelectionChange", "onTokenClose", "options", "placeholder", "overlayProps", "readOnly", "required", "selectedKey", "selectedKeys", "selectionType", "showOnFocus", "noResultsMsg", "tokenizerRef", "hideDropdownButton", "showAllOptionsOnDropdownOpen", "validationMessage", "value", "mruTitle", "otherGroupHeader", "groupClearTextRenderer", "groupClearHandler"]);
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const [isLoadingAllOptions, setIsLoadingAllOptions] = (0, _react.useState)(false);
  const [willFocusPopover, setWillFocusPopover] = (0, _react.useState)(false);
  const [filterString, setFilterString] = (0, _react.useState)(value);
  const [filteredOptions, setFilteredOptions] = (0, _react.useState)(options);
  const [filteredMruOptions, setFilteredMruOptions] = (0, _react.useState)(mruOptions);
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const [multiSelectOptions, setMultiSelectOptions] = (0, _react.useState)([]);
  const [nudgeBase, setNudgeBase] = (0, _react.useState)(value);
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const [bypassShowOnFocus, setBypassShowOnFocus] = (0, _react.useState)(false);
  const [pendingBlurEvent, setPendingBlurEvent] = (0, _react.useState)(null);
  const textInputRef = (0, _react.useRef)(null);
  const tokenizerContainerRef = (0, _react.useRef)();
  const overflowTokenRef = (0, _react.useRef)(null);
  const internalDropdownTriggerButtonRef = (0, _react.useRef)(null);
  const popperBodyRef = (0, _react.useRef)(null);
  const listBoxRef = (0, _react.useRef)(null);
  const inputControlRef = (0, _react.useRef)(null);
  const {
    isMultiSelect,
    selectionType: multiSelectionType
  } = (0, _react.useContext)(_ComboBoxContext.ComboBoxContext) || {};
  const comboBoxSelectionType = multiSelectionType || selectionType;
  const screenReaderContentId = (0, _useUniqueId.default)();
  const matcherMethodMutated = comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'manual' ? matcherMethod : 'startsWith';
  let componentId = (0, _useUniqueId.default)();
  if (id) {
    componentId = id;
  }
  let labelId = (0, _useUniqueId.default)();
  if (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) {
    labelId = labelProps.id;
  }
  let listboxId = (0, _useUniqueId.default)();
  if (listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.id) {
    listboxId = listboxProps.id;
  }
  const emptyFilterOptions = !(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filterableMruOptions ? !(filteredMruOptions === null || filteredMruOptions === void 0 ? void 0 : filteredMruOptions.length) : true);
  const getIsExpanded = expanded => {
    // check to see if there's a reason we can't just use the 'expanded' value
    if (emptyFilterOptions && hideNoResultsMsg) {
      return false;
    }
    return expanded;
  };
  // update filterString (state) and input field text to newString
  const updateFilterStringAndInputText = newString => {
    if (!showAllOptionsOnDropdownOpen) {
      setFilterString(newString || '');
    }
    if (textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) {
      setInputValue(newString || '');
    }
  };
  const updateFilteredOptions = () => {
    if (filterable) {
      const newFilteredOptions = (0, _utils.getFilteredOptions)({
        searchString: filterString,
        options,
        itemText,
        matcherMethod: matcherMethodMutated
      });
      setFilteredOptions(newFilteredOptions);
    } else {
      setFilteredOptions(options);
    }
    if (filterableMruOptions) {
      const newFilteredMruOptions = (0, _utils.getFilteredOptions)({
        searchString: filterString,
        options: mruOptions,
        itemText,
        matcherMethod: matcherMethodMutated
      });
      setFilteredMruOptions(newFilteredMruOptions);
    } else {
      // These may have been cleared when clicking the overflow token
      setFilteredMruOptions(mruOptions);
    }
  };
  // map props.options, props.filterable,
  // or filterString (state) changes to -> filteredOptions (state)
  (0, _react.useEffect)(() => {
    updateFilteredOptions();
  }, [options, filterString, filterable, mruOptions, filterableMruOptions]);
  const queueListboxFocus = () => {
    setTimeout(() => {
      var _a, _b;
      if (listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current) {
        (_b = (_a = listBoxRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        setWillFocusPopover(false);
      }
    }, 0);
  };
  // if loading options as a result of showAllOptionsOnDropdownOpen,
  // ensure filtered options is reset
  (0, _react.useEffect)(() => {
    if (!isLoading && isLoadingAllOptions) {
      setFilteredOptions(options);
      setFilteredMruOptions(mruOptions);
      setIsLoadingAllOptions(false);
    } else if (!isLoading) {
      if (willFocusPopover) {
        queueListboxFocus();
      }
    }
  }, [isLoading]);
  // map props.value changes to -> filterString (state) and input field text
  (0, _react.useEffect)(() => {
    updateFilterStringAndInputText(value);
    setNudgeBase(value);
    if (!value) {
      setSelectedOption(undefined);
    }
  }, [value]);
  // check if noResultsMsg is visible
  (0, _react.useEffect)(() => {
    // if expanded, hide dropdown if filteredOptions is empty and hideNoResultsMsg is true
    if (isExpanded && emptyFilterOptions && hideNoResultsMsg) {
      setIsExpanded(false);
    }
  }, [isExpanded, emptyFilterOptions, hideNoResultsMsg]);
  // trigger dropdown callbacks
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (isExpanded && onDropdownOpen && (0, _isFunction.isFunction)(onDropdownOpen)) {
      onDropdownOpen();
    } else if (!isExpanded && onDropdownClose && (0, _isFunction.isFunction)(onDropdownClose)) {
      onDropdownClose();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(() => {
    if (willFocusPopover) {
      queueListboxFocus();
    }
  }, [willFocusPopover]);
  (0, _react.useEffect)(() => {
    if (pendingBlurEvent && !isExpanded && (0, _isFunction.isFunction)(onBlur)) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(pendingBlurEvent);
      setPendingBlurEvent(null);
    }
  }, [isExpanded, pendingBlurEvent]);
  const getPlaceholderOption = text => ({
    [itemKey !== null && itemKey !== void 0 ? itemKey : NOT_FOUND_KEY]: NOT_FOUND_KEY,
    [itemText !== null && itemText !== void 0 ? itemText : text]: text
  });
  const safeOnSelectionChange = (event, option, reason) => {
    if ((0, _isFunction.isFunction)(onSelectionChange)) {
      onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(event, option, reason);
    }
  };
  // if passed option has a different key value than that of the currently selected option
  // update the currently selected option to the passed option,
  // and trigger props.onSelectionChange callback.
  const selectAndCallback = (event, option, reason, selectedItems) => {
    if (isMultiSelect) {
      safeOnSelectionChange(event, selectedItems, reason);
    } else if ((0, _listboxUtils.reduceOption)(option, itemKey) === NOT_FOUND_KEY || !(0, _utils.isSame)(selectedOption, option, itemKey)) {
      setSelectedOption(option);
      safeOnSelectionChange(event, option, reason);
    }
  };
  // For single select Combobox:
  //  if props.selectedKey changes, update selectedOption,
  //  filterString, and input field text and trigger selection callback
  (0, _react.useEffect)(() => {
    const preSelectedOption = options === null || options === void 0 ? void 0 : options.find(option => (0, _listboxUtils.reduceOption)(option, itemKey) === selectedKey);
    const currentKey = selectedOption ? (0, _listboxUtils.reduceOption)(selectedOption, itemKey) : NOT_FOUND_KEY;
    const isChanged = currentKey !== selectedKey;
    if (isChanged) {
      if (selectedKey === NOT_FOUND_KEY) {
        selectAndCallback({}, getPlaceholderOption(value !== null && value !== void 0 ? value : ''), 'preSelection', null);
        updateFilterStringAndInputText(value);
      } else if (preSelectedOption) {
        selectAndCallback({}, preSelectedOption, 'preSelection', null);
        updateFilterStringAndInputText((0, _listboxUtils.reduceOption)(preSelectedOption, itemText));
      }
    }
  }, [selectedKey, options, value]);
  // For MultiCombobox:
  //  if props.selectedKeys changes, update multiSelectedOptions
  (0, _react.useEffect)(() => {
    const preselectedOptions = [];
    if (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.length) {
      selectedKeys.forEach(key => {
        const matchedObject = options === null || options === void 0 ? void 0 : options.find(option => (0, _listboxUtils.reduceOption)(option, itemKey) === key);
        preselectedOptions.push(matchedObject);
      }, {});
    }
    if (preselectedOptions.length) {
      setMultiSelectOptions(preselectedOptions);
    } else {
      setMultiSelectOptions([]);
    }
  }, [selectedKeys, options]);
  const classnames = _bind.default.bind(_ComboBox.default);
  // DOM and State Manipulation
  const closePopover = () => {
    setIsExpanded(false);
    updateFilteredOptions();
  };
  const openAndFocusPopover = () => {
    const expandedValue = getIsExpanded(true);
    setIsExpanded(expandedValue);
    setWillFocusPopover(expandedValue);
  };
  const queueInputFocus = callback => {
    var _a;
    if ((_a = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _a === void 0 ? void 0 : _a.focus) {
      setTimeout(() => {
        var _a, _b, _c, _d;
        const end = ((_b = (_a = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) || 0;
        (_c = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _c === void 0 ? void 0 : _c.setSelectionRange(end, end);
        (_d = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _d === void 0 ? void 0 : _d.focus();
        if (callback && (0, _isFunction.isFunction)(callback)) {
          callback();
        }
      }, 0);
    }
  };
  const safeOnChange = event => {
    if (onChange && (0, _isFunction.isFunction)(onChange)) {
      onChange(event);
    }
  };
  const reset = event => {
    closePopover();
    selectAndCallback(event, getPlaceholderOption(''), 'escKeyDown', null);
    updateFilterStringAndInputText();
    safeOnChange(event);
    queueInputFocus();
  };
  // returns true if someOption is found in multiSelectOptions (state)
  const inMultiSelectedOptions = someOption => !!multiSelectOptions.find(eachSelectedOption => (0, _utils.isSame)(eachSelectedOption, someOption, itemKey));
  // removes removedOption from multiSelectOptions (state)
  const removeOption = (removedOption, event, reason) => {
    const filteredSelectedOptions = multiSelectOptions.filter(eachOption => !(0, _utils.isSame)(eachOption, removedOption, itemKey));
    setMultiSelectOptions(filteredSelectedOptions);
    selectAndCallback(event, undefined, reason, filteredSelectedOptions);
  };
  // set selected option, and trigger selection callback
  //
  // if MultiCombobox: add option if not already added else remove it.
  //
  // if Combobox: use option.text as filter string and
  //  set input value to value returned by itemText
  // and close the popover.
  const selectUpdateClose = (event, option, reason) => {
    if (isMultiSelect) {
      if (!inMultiSelectedOptions(option)) {
        setMultiSelectOptions([option, ...multiSelectOptions]);
        selectAndCallback(event, option, reason, [option, ...multiSelectOptions]);
      } else {
        removeOption(option, event, reason);
      }
    } else {
      const optionText = (0, _listboxUtils.reduceOption)(option, itemText);
      selectAndCallback(event, option, reason, '');
      setInputValue(optionText);
      setFilterString(optionText);
      closePopover();
    }
  };
  // String, collection, and DOM utils
  // get the first option from filteredOptions,
  // if no filteredOptions (based on searchString) return placeholder option.
  const getFirstFilteredOption = searchString => {
    const matchedOptions = (0, _utils.getFilteredOptions)({
      searchString,
      options,
      itemText,
      matcherMethod: matcherMethodMutated
    });
    return (matchedOptions === null || matchedOptions === void 0 ? void 0 : matchedOptions.length) ? matchedOptions[0] : getPlaceholderOption(searchString);
  };
  // get the first option filteredOption and select it
  const autoSelectFirstOption = (event, searchString, reason) => {
    if (searchString) {
      const firstOption = getFirstFilteredOption(searchString);
      if (firstOption) {
        selectUpdateClose(event, firstOption, reason);
      }
    }
  };
  // create input field text selection for various browsers,
  // this is used to show the type-ahead nudge
  const createSelection = (field, start, end) => {
    if (field === null || field === void 0 ? void 0 : field.createTextRange) {
      const selRange = field.createTextRange();
      selRange.collapse(true);
      selRange.moveStart('character', start);
      selRange.moveEnd('character', end);
      selRange.select();
    } else if (field === null || field === void 0 ? void 0 : field.setSelectionRange) {
      field.setSelectionRange(start, end);
    } else if (field === null || field === void 0 ? void 0 : field.selectionStart) {
      // eslint-disable-next-line no-param-reassign
      field.selectionStart = start;
      // eslint-disable-next-line no-param-reassign
      field.selectionEnd = end;
    }
  };
  let getTokens;
  if (tokenizerContainerRef === null || tokenizerContainerRef === void 0 ? void 0 : tokenizerContainerRef.current) {
    const currentElement = tokenizerContainerRef.current;
    getTokens = () => (0, _tabbable.tabbable)(currentElement);
  }
  const getActiveTokenIndex = tokens => {
    if (!tokens.length) return -1;
    let activeTokenIndex = -1;
    for (let i = 0; i < tokens.length; i += 1) {
      if (tokens[i] === document.activeElement) {
        activeTokenIndex = i;
        break;
      }
    }
    return activeTokenIndex;
  };
  // focus on the last token in the tokenizer,
  // this can either be an option token or the overflow token [x more]
  const focusLastToken = () => {
    const tokens = getTokens();
    if (tokens.length) {
      const lastToken = tokens[tokens.length - 1];
      lastToken === null || lastToken === void 0 ? void 0 : lastToken.focus();
    } else {
      queueInputFocus(); // fallback focus on input
    }
  };
  // if any tokens (except for the first) are active element, set focus on the previous
  const focusPreviousToken = () => {
    const tokens = getTokens();
    const activeTokenIndex = getActiveTokenIndex(tokens);
    const previousToken = activeTokenIndex >= 1 ? tokens[activeTokenIndex - 1] : undefined;
    previousToken === null || previousToken === void 0 ? void 0 : previousToken.focus();
  };
  // if any tokens (except for last) are active element, set focus on the next
  // if last token is active element, focus on input
  const focusNextToken = () => {
    const tokens = getTokens();
    const activeTokenIndex = getActiveTokenIndex(tokens);
    if (activeTokenIndex === tokens.length - 1) {
      queueInputFocus();
    } else {
      const nextToken = activeTokenIndex >= 0 && activeTokenIndex < tokens.length - 1 ? tokens[activeTokenIndex + 1] : undefined;
      nextToken === null || nextToken === void 0 ? void 0 : nextToken.focus();
    }
  };
  const focusTokenByIndex = indexToFocus => {
    const tokens = getTokens();
    const tokenToFocus = tokens[indexToFocus];
    tokenToFocus === null || tokenToFocus === void 0 ? void 0 : tokenToFocus.focus();
  };
  // Event handling
  const handleTriggerButtonClick = event => {
    event.preventDefault();
    if (!isExpanded) {
      openAndFocusPopover();
      if (showAllOptionsOnDropdownOpen) {
        setFilteredOptions(options);
        setFilteredMruOptions(mruOptions);
        setIsLoadingAllOptions(true);
      }
    } else if (isExpanded && event.type === 'click') {
      closePopover();
    }
  };
  const handleTriggerButtonKeyDown = event => {
    const keyCodeString = (0, _keycode.default)(event);
    if (keyCodeString === 'tab' || keyCodeString === 'esc') {
      closePopover();
    }
  };
  const handleInputKeyDown = event => {
    var _a, _b, _c, _d;
    const textFieldValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
    switch ((0, _keycode.default)(event)) {
      case 'backspace':
        setInputValue(filterString);
        // cursor at the very beginning of the input field
        // no text selected in the input field
        if (isMultiSelect && ((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.selectionStart) === 0 && ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.selectionEnd) === 0) {
          focusLastToken();
        }
        break;
      case 'enter':
        switch (comboBoxSelectionType) {
          case 'manual':
            event.preventDefault();
            break;
          default:
            event.preventDefault();
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;
        }
        break;
      case 'esc':
        reset(event);
        break;
      case 'tab':
        switch (comboBoxSelectionType) {
          case 'auto':
          case 'auto-inline':
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;
          default:
        }
        closePopover();
        break;
      case 'down':
      case 'up':
        {
          if (!readOnly && !disabled) {
            openAndFocusPopover();
            if (showAllOptionsOnDropdownOpen && !isExpanded) {
              setFilteredOptions(options);
              setFilteredMruOptions(mruOptions);
              setIsLoadingAllOptions(true);
            }
          }
          break;
        }
      case 'left':
        {
          if (isMultiSelect && ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.selectionStart) === 0) {
            focusLastToken();
          }
        }
      // eslint-disable-next-line no-fallthrough
      case 'right':
        setFilterString(textFieldValue);
        break;
      default:
    }
  };
  const handleInputChange = event => {
    var _a;
    const targetInputValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
    setNudgeBase(targetInputValue);
    setFilterString(targetInputValue);
    setInputValue(targetInputValue);
    if (targetInputValue === null || targetInputValue === void 0 ? void 0 : targetInputValue.trim()) {
      setIsExpanded(getIsExpanded(true));
      switch (comboBoxSelectionType) {
        case 'manual':
          selectAndCallback(event, getPlaceholderOption(targetInputValue), 'inputChange', '');
          break;
        case 'auto':
          selectAndCallback(event, getFirstFilteredOption(targetInputValue), 'inputChange', '');
          break;
        case 'type-ahead':
        case 'auto-inline':
          {
            // try type ahead nudge
            const firstOption = getFirstFilteredOption(targetInputValue);
            if (firstOption) {
              const optionText = (0, _listboxUtils.reduceOption)(firstOption, itemText);
              if ((0, _listboxUtils.matcherMethodIgnoreCase)(optionText, targetInputValue, matcherMethodMutated) && textInputRef.current) {
                textInputRef.current.value = optionText;
                createSelection(textInputRef.current, targetInputValue === null || targetInputValue === void 0 ? void 0 : targetInputValue.length, optionText === null || optionText === void 0 ? void 0 : optionText.length);
                setInputValue(optionText);
              }
            }
            if (comboBoxSelectionType === 'auto-inline') {
              selectAndCallback(event, firstOption, 'inputChange', '');
            }
            break;
          }
        default:
      }
    } else {
      selectAndCallback(event, getPlaceholderOption(targetInputValue), 'inputChange', '');
      if ((0, _isFunction.isFunction)(showOnFocus) && (showOnFocus === null || showOnFocus === void 0 ? void 0 : showOnFocus(event))) {
        return;
      }
      closePopover();
    }
  };
  const handleInputBlur = event => {
    setBypassShowOnFocus(false);
    switch (comboBoxSelectionType) {
      case 'manual':
        if (!(0, _listboxUtils.reduceOption)(selectedOption, itemKey) && (filterString === null || filterString === void 0 ? void 0 : filterString.trim().length)) {
          safeOnSelectionChange(event, getPlaceholderOption(filterString), 'inputBlur');
        }
        break;
      case 'auto':
        setFilterString(event.target.value);
        break;
      case 'auto-inline':
        break;
      case 'type-ahead':
        {
          setInputValue(nudgeBase);
          break;
        }
      default:
    }
  };
  const handleOptionKeyDown = event => {
    var _a;
    const keyCode = (0, _keycode.default)(event);
    switch (keyCode) {
      case 'tab':
        {
          closePopover();
          (_a = internalDropdownTriggerButtonRef === null || internalDropdownTriggerButtonRef === void 0 ? void 0 : internalDropdownTriggerButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
          break;
        }
      case 'home':
      case 'end':
        {
          event.preventDefault();
          event.stopPropagation();
          queueInputFocus(() => {
            var _a, _b;
            if (textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) {
              const cursorPos = keyCode === 'home' ? 0 : (_b = (_a = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length;
              setTimeout(() => {
                createSelection(textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current, cursorPos, cursorPos);
              }, 0);
            }
          });
          break;
        }
      default:
        break;
    }
  };
  const handleOverflowTokenClick = event => {
    if (disabled) return;
    if (!readOnly) {
      if (!isExpanded) {
        setFilteredOptions(multiSelectOptions);
        setFilteredMruOptions([]);
        openAndFocusPopover();
      } else {
        closePopover();
        setFilteredOptions(options);
        setFilteredMruOptions(mruOptions);
      }
    }
    onOverflowTokenClick === null || onOverflowTokenClick === void 0 ? void 0 : onOverflowTokenClick(event);
  };
  const handleTokenClose = (event, removedOption) => {
    if (disabled) return;
    if (!readOnly) {
      removeOption(removedOption, event, 'tokenRemoved');
      if (event) {
        onTokenClose === null || onTokenClose === void 0 ? void 0 : onTokenClose(event, removedOption);
      }
    }
  };
  const handleTokenKeyDown = (event, targetOption) => {
    if (disabled) return;
    switch ((0, _keycode.default)(event)) {
      case 'delete':
      case 'backspace':
        {
          if (!readOnly) {
            const tokenIndex = getActiveTokenIndex(getTokens());
            handleTokenClose(event, targetOption);
            setTimeout(() => {
              focusLastToken();
              focusTokenByIndex(tokenIndex);
            }, 0);
          }
          break;
        }
      case 'left':
        {
          setTimeout(() => {
            focusPreviousToken();
          }, 0);
          break;
        }
      case 'right':
        {
          setTimeout(() => {
            focusNextToken();
          }, 0);
          break;
        }
      case 'tab':
        {
          if ((textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) && !(event === null || event === void 0 ? void 0 : event.shiftKey) && !readOnly) {
            event.preventDefault();
            textInputRef.current.focus();
          }
          break;
        }
      default:
        break;
    }
  };
  // Rendering
  const optionContent = ({
    option,
    highlightMatchingText = true
  }) => {
    var _a, _b;
    const optionText = (0, _listboxUtils.reduceOption)(option, itemText);
    if ((0, _isFunction.isFunction)(mruListItemRenderer) && (option === null || option === void 0 ? void 0 : option.isMru)) {
      return mruListItemRenderer === null || mruListItemRenderer === void 0 ? void 0 : mruListItemRenderer(option);
    }
    if ((0, _isFunction.isFunction)(listItemRenderer)) {
      return listItemRenderer === null || listItemRenderer === void 0 ? void 0 : listItemRenderer(option);
    }
    let filterStringLength = 0;
    if (filterString) {
      filterStringLength = filterString.length;
    }
    if (!highlightMatchingText || !filterStringLength) {
      return optionText;
    }
    const firstOccurrence = (_a = optionText === null || optionText === void 0 ? void 0 : optionText.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(optionText).indexOf((_b = filterString === null || filterString === void 0 ? void 0 : filterString.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(filterString));
    if (firstOccurrence === -1) {
      return optionText;
    }
    const leftPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(0, firstOccurrence);
    const matchingPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(firstOccurrence, firstOccurrence + filterStringLength);
    const rightPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(firstOccurrence + filterStringLength);
    return /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(`${CSS_BLOCK}__filtered-item`)
    }, leftPart, /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(`${CSS_BLOCK}__match`)
    }, matchingPart), rightPart);
  };
  const listboxClasses = classnames(`${CSS_BLOCK}__listbox`);
  const getNoResultsScreenReaderText = () => {
    if (noResultsMsg) {
      if ((0, _isString.isString)(noResultsMsg)) {
        return noResultsMsg;
      }
      return `${noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.title}, ${noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.description}`;
    }
    return '';
  };
  const editable = !disabled && !readOnly;
  let screenReaderStatus = '';
  if (isLoading && loadingMessage) {
    screenReaderStatus = loadingMessage;
  } else if (emptyFilterOptions && !hideNoResultsMsg) {
    screenReaderStatus = getNoResultsScreenReaderText();
  }
  const screenReaderContent = editable ? (/*#__PURE__*/_react.default.createElement("span", {
    className: classnames(`${CSS_BLOCK}--screen-reader-only`),
    id: screenReaderContentId,
    role: "status"
  }, (screenReaderStatus === null || screenReaderStatus === void 0 ? void 0 : screenReaderStatus.length) > 0 && screenReaderStatus)) : null;
  const isMessageObject = msg => typeof msg === 'object' && msg !== null;
  const noResultsContent = () => (
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-useless-fragment
  _react.default.createElement(_react.default.Fragment, null, !(infinite === null || infinite === void 0 ? void 0 : infinite.hasMore) && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__no-results`)
  }, isMessageObject(noResultsMsg) ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, noResultsMsg.title && /*#__PURE__*/_react.default.createElement("div", null, noResultsMsg.title), noResultsMsg.description && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__no-results-description`)
  }, noResultsMsg.description)))) : noResultsMsg), screenReaderContent))));
  const loadingIndicator = () => (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__loading-container`)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__loading`)
  }, /*#__PURE__*/_react.default.createElement(_BusyIndicator.BusyIndicator, {
    message: loadingMessage !== undefined ? loadingMessage : '',
    size: "sm",
    type: "inline",
    visible: true
  })), screenReaderContent));
  const optionsList = () => {
    const {
      isUsingGroups,
      newOptions,
      groupLabelRenderer
    } = (0, _listOptions.getOptionsList)({
      options: filteredOptions,
      mruOptions: (filterString === null || filterString === void 0 ? void 0 : filterString.length) === 0 || filterableMruOptions ? filteredMruOptions : undefined,
      groupBy,
      mruTitle,
      otherGroupHeader
    });
    // this is only needed for auto-inline and auto selection types
    const handleSelect = (event, optionKeyValue) => {
      const optionData = options === null || options === void 0 ? void 0 : options.find(option => optionKeyValue === (0, _listboxUtils.reduceOption)(option, itemKey));
      if ((comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'auto-inline') && ((event === null || event === void 0 ? void 0 : event.type) === 'click' || (0, _isEnterOrSpace.isEnterOrSpace)(event))) {
        selectUpdateClose(event, optionData, 'optionSelected');
        setBypassShowOnFocus(true);
        queueInputFocus();
      }
    };
    const handleSingleSelection = (event, optionKeyValue) => {
      const optionData = options === null || options === void 0 ? void 0 : options.find(option => optionKeyValue === (0, _listboxUtils.reduceOption)(option, itemKey));
      if ((comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'auto-inline') && (event === null || event === void 0 ? void 0 : event.type) !== 'click' && !(0, _isEnterOrSpace.isEnterOrSpace)(event)) {
        selectAndCallback(event, optionData, 'optionFocus', '');
        setInputValue((0, _listboxUtils.reduceOption)(optionData, itemText));
      } else {
        selectUpdateClose(event, optionData, 'optionSelected');
        setBypassShowOnFocus(true);
        queueInputFocus();
      }
    };
    const handleMultiSelectionChange = (event, optionKeyValue) => {
      const optionData = options === null || options === void 0 ? void 0 : options.find(option => optionKeyValue === (0, _listboxUtils.reduceOption)(option, itemKey));
      selectUpdateClose(event, optionData, 'optionToggled');
    };
    const currentSelectedKey = (0, _listboxUtils.reduceOption)(selectedOption, itemKey);
    let content = /*#__PURE__*/_react.default.createElement(_Listbox.Listbox, Object.assign({}, listboxProps, {
      id: listboxId,
      ariaLabelledby: labelId,
      className: listboxClasses,
      groupLabelRenderer: isUsingGroups ? groupLabelRenderer : undefined,
      hideOuterFocusRing: true,
      ignoreFirstAndLastKeys: true,
      infinite: infinite,
      itemKey: itemKey,
      itemText: itemText,
      listItemRenderer: option => optionContent({
        option,
        highlightMatchingText: (option === null || option === void 0 ? void 0 : option.isMru) ? filterableMruOptions : true
      }),
      listItemProps: listItemProps,
      maxHeight: maxHeight,
      selectedKey: currentSelectedKey !== NOT_FOUND_KEY ? currentSelectedKey : undefined,
      selectedKeys: multiSelectOptions.map(option => (0, _listboxUtils.reduceOption)(option, itemKey)),
      selectionType: isMultiSelect ? 'multiSelect' : 'singleSelectMaster',
      selectionFollowsFocus: comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'auto-inline',
      options: isUsingGroups ? newOptions : newOptions[0],
      onKeyDown: handleOptionKeyDown,
      onSelect: handleSelect,
      onChange: handleSingleSelection,
      onSelectionChange: handleMultiSelectionChange,
      groupClearHandler: groupClearHandler,
      groupClearTextRenderer: groupClearTextRenderer,
      ref: listBoxRef
    }));
    if (emptyFilterOptions) {
      content = noResultsContent();
    }
    return content;
  };
  const popperBody = () => (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__popper-contents`)
  }, validationMessage && validationMessage.state && validationMessage.text && (/*#__PURE__*/_react.default.createElement(_ValidationMessage.ValidationMessage, {
    inPopper: true,
    state: validationMessage.state,
    text: validationMessage.text
  })), !isLoading ? optionsList() : loadingIndicator()));
  const classes = classnames(CSS_BLOCK, className);
  const getInputStartDecorators = () => {
    const decoratorArray = [];
    const getLocalizedLabel = () => {
      if (!localizedTextAddendum) {
        return undefined;
      }
      if ('tokenRemoveLabel' in localizedTextAddendum) {
        return localizedTextAddendum.tokenRemoveLabel;
      }
      if ('tokenCloseLabel' in localizedTextAddendum) {
        return localizedTextAddendum.tokenCloseLabel;
      }
      return undefined;
    };
    if (isMultiSelect) {
      decoratorArray.push(/*#__PURE__*/_react.default.createElement(_MultiComboBoxTokenizer.MultiComboBoxTokenizer, {
        itemKey: itemKey,
        itemText: itemText,
        onClose: handleTokenClose,
        onKeyDown: handleTokenKeyDown,
        onOverflowTokenClick: handleOverflowTokenClick,
        removeLabel: getLocalizedLabel(),
        overflowTokenLabel: localizedTextAddendum && localizedTextAddendum.more ? localizedTextAddendum.more : '',
        ref: (0, _reactMergeRefs.default)([tokenizerContainerRef, tokenizerRef]),
        selectedOptions: multiSelectOptions,
        overflowTokenRef: overflowTokenRef,
        reservedWidthForSiblings: 275
      }));
    }
    return [...decoratorArray, ..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputStart)];
  };
  const getInputEndDecorators = () => {
    const decoratorArray = [];
    if (!hideDropdownButton) {
      decoratorArray.push(/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, dropdownTriggerButtonProps, {
        ariaLabel: dropdownTriggerLabel,
        className: classnames(dropdownTriggerButtonProps === null || dropdownTriggerButtonProps === void 0 ? void 0 : dropdownTriggerButtonProps.className),
        disabled: disabled || emptyFilterOptions && hideNoResultsMsg,
        id: `${componentId}-combobox-arrow`,
        onClick: (0, _chainFunction.default)(handleTriggerButtonClick, onDropdownTriggerClick),
        onKeyDown: (0, _chainFunction.default)(handleTriggerButtonKeyDown, dropdownTriggerButtonProps === null || dropdownTriggerButtonProps === void 0 ? void 0 : dropdownTriggerButtonProps.onKeyDown),
        ref: (0, _reactMergeRefs.default)([internalDropdownTriggerButtonRef, dropdownTriggerButtonRef]),
        iconName: dropdownTriggerIconName
      })));
    }
    return [..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputEnd), ...decoratorArray];
  };
  let describedbyString;
  if (typeof inputDescribedby === 'string') {
    describedbyString = inputDescribedby;
  } else if (Array.isArray(inputDescribedby)) {
    describedbyString = (_a = inputDescribedby.join) === null || _a === void 0 ? void 0 : _a.call(inputDescribedby, ' ');
  }
  let itemCountMessage = '';
  const itemCount = ((filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) || 0) + ((filteredMruOptions === null || filteredMruOptions === void 0 ? void 0 : filteredMruOptions.length) || 0);
  if (isExpanded && itemCount > 0 && inputValue && !isLoading) {
    itemCountMessage = `${itemCountScreenReaderLabel} ${itemCount}`;
  }
  const renderInputField = popperTargetRef => (/*#__PURE__*/_react.default.createElement(_InputField.InputField, Object.assign({}, otherProps, {
    disableInternalValueStateMgmt: comboBoxSelectionType === 'type-ahead' || comboBoxSelectionType === 'auto-inline',
    enableScreenReaderStatus: !disabled && !readOnly,
    screenReaderMessage: itemCountMessage,
    inputDescribedby: editable && (isLoading || emptyFilterOptions) && isExpanded ? `${describedbyString || ''} ${screenReaderContentId}`.trim() : describedbyString,
    "aria-controls": isExpanded ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.id : undefined,
    className: classes,
    decorators: Object.assign(Object.assign({}, decorators), {
      inputStart: getInputStartDecorators(),
      inputEnd: getInputEndDecorators()
    }),
    disabled: disabled,
    helpText: helpText,
    id: `${componentId}-combobox`,
    label: label,
    labelProps: Object.assign(Object.assign({}, labelProps), {
      id: labelId
    }),
    onBlur: (0, _chainFunction.default)(handleInputBlur, event => {
      setPendingBlurEvent(event);
    }),
    onChange: (0, _chainFunction.default)(handleInputChange, safeOnChange),
    onFocus: event => {
      var _a;
      if ((0, _isFunction.isFunction)(showOnFocus) && !readOnly && !disabled) {
        if (!bypassShowOnFocus) {
          if (showAllOptionsOnDropdownOpen) {
            setFilteredOptions(options);
            setFilteredMruOptions(mruOptions);
            setIsLoadingAllOptions(true);
          }
          setIsExpanded(getIsExpanded((_a = showOnFocus === null || showOnFocus === void 0 ? void 0 : showOnFocus(event)) !== null && _a !== void 0 ? _a : false));
        }
      }
      if ((0, _isFunction.isFunction)(onFocus)) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
      }
    },
    placeholder: placeholder,
    inputProps: Object.assign(Object.assign({
      autoComplete: 'off',
      spellCheck: 'false',
      autoCorrect: 'off',
      autoCapitalize: 'off'
    }, inputProps), {
      id: componentId,
      role: 'combobox',
      'aria-expanded': isExpanded,
      'aria-haspopup': editable ? 'listbox' : false,
      'aria-controls': isExpanded ? listboxId : undefined,
      'aria-autocomplete': comboBoxSelectionType === 'auto-inline' ? 'both' : 'list',
      onKeyDown: (0, _chainFunction.default)(handleInputKeyDown, event => {
        if ((0, _isFunction.isFunction)(onKeyDown)) {
          onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        }
      }),
      onMouseDown: event => {
        if ((0, _isFunction.isFunction)(onMouseDown)) {
          onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        }
      }
    }),
    inputRef: (0, _reactMergeRefs.default)([textInputRef, inputRef]),
    controlRef: (0, _reactMergeRefs.default)([controlRef, inputControlRef, popperTargetRef]),
    readOnly: readOnly,
    ref: ref,
    required: required,
    value: inputValue || '',
    validationMessage: validationMessage,
    hideValidationMessage: isExpanded
  })));
  return /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, Object.assign({}, overlayProps, {
    popperPlacement: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperPlacement) || ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
    widthSizingType: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.widthSizingType) || 'minTarget',
    onEscapeKey: (0, _chainFunction.default)(() => {
      setBypassShowOnFocus(true);
      closePopover();
      queueInputFocus();
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onEscapeKey),
    onHide: (0, _chainFunction.default)(() => {
      closePopover();
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onHide),
    popperProps: Object.assign(Object.assign({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      innerRef: (0, _reactMergeRefs.default)([popperBodyRef, (_b = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _b === void 0 ? void 0 : _b.innerRef]),
      role: 'presentation'
    }),
    renderTargetComponent: renderInputField,
    show: isExpanded,
    disableFocusManager: true,
    skipTargetModifications: true
  }), popperBody());
});
ComboBox.displayName = 'ComboBox';
var _default = exports.default = ComboBox;